import pools from '@/constants/pools';
import config from '@/constants/config';
import { arrayToHashmap } from '@/utils/helpers';

import memoize from 'memoizee';

// Stats pool id -> internal pool id
const statsPoolIdResolver = (statsPoolId) => pools.find(({ statsId }) => statsId === statsPoolId)?.id || statsPoolId;

const normalizePoolIds = (stats) => ({
    volume: stats.volume ? arrayToHashmap(Array.from(Object.entries(stats.volume)).map(([statsPoolId, value]) => [
        statsPoolIdResolver(statsPoolId),
        value,
    ])) : stats.volume,
    apy: arrayToHashmap(['day', 'week', 'month', 'total'].map((period) => [
        period,
        stats.apy?.[period] ? arrayToHashmap(Array.from(Object.entries(stats.apy[period])).map(([statsPoolId, value]) => [
            statsPoolIdResolver(statsPoolId),
            value,
        ])) : stats.apy?.[period],
    ])),
});

const getStats = memoize(async (url) => (
    normalizePoolIds(await (await fetch(url)).json())
), {
    promise: true,
    maxAge: 60 * 1000, // 1 min
});

const getMainPoolsStats = () => getStats(`https://api.curve.finance/api/getMainPoolsAPYs/${config.blockchainId}`);
const getCryptoPoolsStats = () => getStats(`https://api.curve.finance/api/getMainPoolsAPYs/${config.blockchainId}`);
// const getCryptoPoolsStats = () => getStats(`${window.domain}/${config.rawStatsPath}-crypto/apys.json`);

const getSubgraphStats = memoize(async () => (
    (await fetch(config.subgraphStatsEndpoint)).json()
), {
    promise: true,
    maxAge: 60 * 1000, // 1 min
});

export {
    getMainPoolsStats,
    getCryptoPoolsStats,
    getSubgraphStats,
}
